var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noprint"},[(_vm.message)?_c('div',{staticClass:"snackbar rounded shadow-lg px-3 py-2"},[_c('p',{staticClass:"h5 mb-0 text-white"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }